import { Text } from '@mantine/core';

import classes from './typography.module.css';

export const TextOverride = Text.extend({
  classNames: { root: classes.root },
});
